export default __webpack_public_path__ + "static/media/Phoneproject.a989e17a.png";